"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Title = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _FormattedComposite = _interopRequireDefault(require("../FormattedComposite/FormattedComposite"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for title
 */
const Title = ({
  tag: Tag,
  size,
  content,
  border,
  status,
  className,
  data,
  ...props
}) => {
  if (data) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Tag, {
      className: (0, _classnames.default)('ccl__title', `ccl__title--${size}`, border ? 'ccl__title--border' : '', status ? 'ccl__title--has-status' : '', className || ''),
      ...props,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedComposite.default, {
        config: {
          format: content,
          type: 'composite'
        },
        data: data
      }), !!status && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: ['ccl__title__align-end ccl__text'],
        children: status
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Tag, {
    className: (0, _classnames.default)('ccl__title', `ccl__title--${size}`, border ? 'ccl__title--border' : '', status ? 'ccl__title--has-status' : '', className || ''),
    ...props,
    children: [content, !!status && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: ['ccl__title__align-end ccl__text'],
      children: status
    })]
  });
};
exports.Title = Title;
Title.defaultProps = {
  size: 'heading-1',
  border: false
};